module.exports = {"350182001":"吴航街道","350182002":"航城街道","350182003":"营前街道","350182004":"漳港街道","350182102":"首占镇","350182103":"玉田镇","350182104":"松下镇","350182105":"江田镇","350182106":"古槐镇","350182107":"文武砂镇","350182108":"鹤上镇","350182110":"湖南镇","350182111":"金峰镇","350182112":"文岭镇","350182113":"梅花镇","350182114":"潭头镇","350182200":"罗联乡","350182201":"猴屿乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350112.json
// module id = 1070
// module chunks = 0